"use strict";
var analytics = require('./analytics');
exports.analytics = analytics;
var SimpleAnalytics = require('./simpleanalytics');
exports.SimpleAnalytics = SimpleAnalytics;
var history = require('./history');
exports.history = history;
var donottrack = require('./donottrack');
exports.donottrack = donottrack;
var storage = require('./storage');
exports.storage = storage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/coveo.analytics/dist/index.js
// module id = 306
// module chunks = 88 89